export default __webpack_public_path__ + "static/ideal-08dd4369d5f80c59b15375a902ebef46.png";